import {connect} from 'react-redux'
import AdCardStructure
  from 'gui/components/listPage/components/ad/components/adCardStructure';


const mapStateToProps = ({gui}, ownProps) => {
  return {
    gui,
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const AdCardStructureContainer = connect(mapStateToProps, mapDispatchToProps)(AdCardStructure as any);

export default AdCardStructureContainer;
